import Api from "./Api";

export default {
    GetAllClients(payload) {
        return Api().get('/clients')
    },
    CreatAClient(payload) {
        return Api().post('/clients', payload)
    },
    UpdateAClient(payload) {
        return Api().put('/clients', payload)
    },
    GetSingleClientDetails(payload) {
        return Api().get(`/client/${payload.client_id}`)
    }
}


// WEBPACK FOOTER //
// ./src/services/ClientService.js